// @ts-nocheck


import queryString from 'query-string';


import {
  fetchRequest,
  downloadRequestWithToken,
  initialFetchListParams } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertDataFromServer as actConvertDataFromServer } from './act';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';


export const convertDataFromServer = (pass) => ({
  ...pass,
  paymentAmount: convertFromKopToRub(pass.paymentAmount),
  paymentAmountPass: convertFromKopToRub(pass.paymentAmountPass),
  paymentAmountTax: convertFromKopToRub(pass.paymentAmountTax),
  act: pass.act ? actConvertDataFromServer(pass.act) : undefined
});

export const convertDataToServer = (pass) => ({
  ...pass,
  paymentAmount: convertFromRubToKop(pass.paymentAmount),
  paymentAmountPass: convertFromRubToKop(pass.paymentAmountPass),
  paymentAmountTax: convertFromRubToKop(pass.paymentAmountTax)
});

export const addPass = async (pass) => {
  const added = await fetchRequest.post('/pass', convertDataToServer(pass));
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось создать пропуск');
};

export const updatePass = async (pass) => {
  const updated = await fetchRequest.put('/pass', convertDataToServer(pass));
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить пропуск');
};
export const deletePass = async (id) => {
  const deleted = await fetchRequest.delete(`/pass/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить пропуск');
};

export const fetchPass = async (
id,
params = {}) =>
{
  const pass = await fetchRequest.get(`/pass/${id}`, params);
  if (pass) return convertDataFromServer(pass);
  throw new Error('Не удалось получить пропуск');
};

export const fetchVehiclePasses = async (
vehicleId,
params = initialFetchListParams) =>
{
  const passes = await fetchRequest.get(`/pass/vehicle/${vehicleId}`, {
    ...initialFetchListParams,
    ...params
  });
  if (passes) {
    return {
      ...passes,
      data: passes.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось список пропусков');
};

export const fetchPasses = async (
params = initialFetchListParams) =>
{
  const passList = await fetchRequest.get('/pass', {
    ...initialFetchListParams,
    ...params
  });
  if (passList) {
    return {
      ...passList,
      data: passList.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось список пропусков');
};

export const updateAct = async (
params,
data) =>
{
  const pass = await fetchRequest.put(
    `/pass/updateActId?${queryString.stringify(params)}`,
    data
  );
  if (pass) {
    return {
      ...pass,
      data: pass.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось закрепить акт за списоком пропусков');
};

export const getTotalSum = async (params = {}) => {
  const sum = await fetchRequest.get(`/pass/totalSum`, params);
  if (sum || sum === 0) return convertFromKopToRub(sum);
  throw new Error('Не удалось получить общую сумму');
};

export const groupedList = async (
params = {}) =>
{
  const groupedList = await fetchRequest.get(`/pass/groupedList`, params);
  if (groupedList)
  return {
    ...groupedList,
    data: groupedList.data.map(convertDataFromServerGroupedList)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export const printReport = async (
params,
fileName) =>
{
  const isPrinted = await downloadRequestWithToken(
    '/pass/print',
    params,
    fileName
  );
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

export default {
  groupedList,
  getTotalSum,
  updateAct,
  addPass,
  updatePass,
  deletePass,
  fetchPass,
  fetchVehiclePasses,
  fetchPasses,
  printReport
};
